import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter, Route, Routes } from 'react-router-dom';

import store, { history } from './store.js';
import App from './App.jsx';
import DateLocalizationController from './components/date-loclization-controller/DateLocalizationController.jsx';
import ThemeProvider from './components/theme/ThemeProvider.jsx';
import { PROJECT_TYPES } from './constants/index';
import CONSUMER_PAGES from './consumer-page/consumerPages.js';
import NotificationsProvider from './notifications/NotificationsProvider.jsx';
import NotificationsWrapper from './notifications/NotificationsWrapper.jsx';
import ContactModalHost from './contact/ContactModalHost.jsx';
import SECURITY_PAGES from './security/SecurityPages.jsx';
import { SpeechChannelProvider } from './context/SpeechChannelContext.jsx';
import ErrorBoundary from './components/error-boundary/ErrorBoundary.jsx';
import CrashProbe from './components/error-boundary/CrashProbe.jsx';
import ConsumerPage from './consumer-page/ConsumerPage.jsx';
import ScoutCollectData from './consumer-page/scout-collect-data/ScoutCollectData.jsx';
import ScoutFinalMessages from './consumer-page/scout-final-messages/ScoutFinalMessages.jsx';
import AdImagesRequest from './ad-images/ad-images-request/AdImagesRequest.jsx';
import ConsumerAdImages from './ad-images/consumer-ad-images/ConsumerAdImages.jsx';

import './i18n/index.js';
import './index.scss';

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <HistoryRouter
      history={history}
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}>
      <ThemeProvider>
        <NotificationsProvider>
          <SpeechChannelProvider>
            <NotificationsWrapper>
              <ErrorBoundary variant='root'>
                <CrashProbe target='root' />
                <Routes>
                  {SECURITY_PAGES.map(({ path, element }) => (
                    <Route exact key={path} path={path} element={element} />
                  ))}
                  <Route path={'*'} element={<App />} />

                  {CONSUMER_PAGES.map(({ path }) => (
                    <Route exact key={path} path={path} element={<ConsumerPage />} />
                  ))}
                  <Route
                    exact
                    path={`/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/collect-data/:projectName`}
                    element={<ScoutCollectData />}
                  />
                  <Route
                    exact
                    path={`/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/final-messages/:projectName`}
                    element={<ScoutFinalMessages />}
                  />
                  <Route exact path={`/ad/images/demo/request`} element={<AdImagesRequest />} />
                  <Route exact path={`/ad/images/demo`} element={<ConsumerAdImages />} />
                </Routes>
                <DateLocalizationController />
              </ErrorBoundary>
              <ContactModalHost />
            </NotificationsWrapper>
          </SpeechChannelProvider>
        </NotificationsProvider>
      </ThemeProvider>
    </HistoryRouter>
  </Provider>,
);
